import { render } from "./IntegracaoPj.vue?vue&type=template&id=3bc7a968"
import script from "./IntegracaoPj.vue?vue&type=script&lang=js"
export * from "./IntegracaoPj.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__